import { toast } from "@/hooks/use-toast";

/**
 * login with Google OAuth
 */
export const signInWithGoogle = async (): Promise<void> => {
  try {
    window.location.assign('/api/v1/auth/google/start?next=%2Fauth%2Fcallback');
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : 'Google sign-in failed';
    toast({
      title: "Error signing in with Google",
      description: message,
      variant: "destructive",
    });
    throw error;
  }
};
